/* CVCraft's unique icon set (Brand B1). Hand-drawn, not a third-party icon library — PSCraft's stroke
   language (16×16 viewBox, currentColor, stroke 1.5, round caps/joins, 1em box) ported into CVCraft's own
   geometry. Replaces the typographic affordance glyphs (↑ ↓ × ✓ ← 🎙 ◼) across the app. `stop` is the one
   fill exception (a small filled square reads as "stop" only when solid). */
import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

const base = {
  viewBox: '0 0 16 16',
  width: '1em',
  height: '1em',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export function IconUp(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M8 12.5V3.5" />
      <path d="M4 7.5L8 3.5L12 7.5" />
    </svg>
  );
}

export function IconDown(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M8 3.5V12.5" />
      <path d="M4 8.5L8 12.5L12 8.5" />
    </svg>
  );
}

export function IconClose(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M4 4L12 12" />
      <path d="M12 4L4 12" />
    </svg>
  );
}

export function IconCheck(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M3.5 8.3L6.3 11.2L12.5 4.8" />
    </svg>
  );
}

export function IconEdit(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M10.3 2.7L13.3 5.7L5 14L2 14.3L2.3 11.3L10.3 2.7Z" />
      <path d="M9 4L12 7" />
    </svg>
  );
}

export function IconCopy(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <rect x="2.5" y="4.5" width="7" height="9" rx="1.2" />
      <path d="M6 4.5V3.2C6 2.5 6.5 2 7.2 2H12.3C13 2 13.5 2.5 13.5 3.2V9.3C13.5 10 13 10.5 12.3 10.5H11" />
    </svg>
  );
}

export function IconDownload(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M8 2V9.5" />
      <path d="M4.8 6.7L8 9.9L11.2 6.7" />
      <path d="M2.5 11.5V12.8C2.5 13.5 3 14 3.7 14H12.3C13 14 13.5 13.5 13.5 12.8V11.5" />
    </svg>
  );
}

export function IconAdd(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M8 3.2V12.8" />
      <path d="M3.2 8H12.8" />
    </svg>
  );
}

export function IconBack(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M12.5 8H3.5" />
      <path d="M7 4L3.5 8L7 12" />
    </svg>
  );
}

export function IconChevronDown(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M3.8 6L8 10.2L12.2 6" />
    </svg>
  );
}

export function IconTrash(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M3 4.8H13" />
      <path d="M6 4.8V3.2C6 2.8 6.4 2.5 6.8 2.5H9.2C9.6 2.5 10 2.8 10 3.2V4.8" />
      <path d="M4.3 4.8L4.9 12.7C4.95 13.3 5.4 13.7 6 13.7H10C10.6 13.7 11.05 13.3 11.1 12.7L11.7 4.8" />
      <path d="M6.7 7.2V11" />
      <path d="M9.3 7.2V11" />
    </svg>
  );
}

export function IconMic(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <rect x="6" y="2" width="4" height="7" rx="2" />
      <path d="M4 8.2C4 10.6 5.8 12.3 8 12.3C10.2 12.3 12 10.6 12 8.2" />
      <path d="M8 12.3V14" />
      <path d="M5.8 14H10.2" />
    </svg>
  );
}

export function IconStop(props: IconProps) {
  return (
    <svg {...base} {...props} fill="currentColor" stroke="none">
      <rect x="4" y="4" width="8" height="8" rx="1" />
    </svg>
  );
}

export function IconMenu(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M3 4.5H13" />
      <path d="M3 8H13" />
      <path d="M3 11.5H13" />
    </svg>
  );
}
